import React, { PropsWithChildren, useState } from 'react';
import { Platform, TouchableWithoutFeedback, View } from 'react-native';

import BorderRadius from '../../theming/BorderRadius';
import Colors from '../../theming/Colors';
import Spacing from '../../theming/Spacing';
import { KitText } from '../index';

export interface IKitTabProps {
  active?: boolean;
  disabled?: boolean;
  onPress?: () => void;
  fontSize?: number;
}
export default function KitTab({
  active,
  children,
  disabled,
  onPress,
  fontSize,
}: PropsWithChildren<IKitTabProps>): JSX.Element {
  const [pressed, setPressed] = useState(false);

  return (
    <TouchableWithoutFeedback
      onPress={onPress}
      onPressIn={() => setPressed(true)}
      onPressOut={() => setPressed(false)}
      disabled={disabled}
    >
      <View
        style={{
          flex: 1,
          justifyContent: 'center',
          backgroundColor: pressed ? Colors.N100 : Colors.N0,
          borderBottomColor: active ? Colors.N900 : Colors.N150,
          borderBottomWidth: active ? 2 : 1,
          transform: [{ scale: pressed ? 0.95 : 1 }],
          opacity: disabled ? 0.5 : 1,
          alignItems: 'center',
          paddingVertical: Spacing.s,
          paddingHorizontal: Spacing.l,
          borderTopLeftRadius: BorderRadius.m,
          borderTopRightRadius: BorderRadius.m,
          ...(Platform.OS === 'web' && {
            cursor: 'pointer',
            'user-select': 'none',
          }),
        }}
      >
        {typeof children === 'string' ? (
          <KitText
            bold={active}
            fontSize={fontSize ? fontSize : 18}
            color={active ? Colors.N900 : Colors.N500}
          >
            {children}
          </KitText>
        ) : (
          children
        )}
      </View>
    </TouchableWithoutFeedback>
  );
}
